// This function is use to merge items in array of string

import normalizeEscapedString from './normalizeEscapedString'

// 2 items will be merge: ['"abc', 'def"'] will be merged into ['"abcdef"'], ['"abc','def', 'gh"'] into ['"abcdefgh"']
export default function mergeEscapeStrings(strings: string[]) {
  let firstQuotes = -1
  return strings.reduce<string[]>((acc, value) => {
    value = normalizeEscapedString(value)
    if (value.startsWith('"') && value.endsWith('"')) {
      acc.push(value)
    } else if (value.startsWith('"')) {
      acc.push(value)
      firstQuotes = acc.length - 1
    } else if (value.endsWith('"')) {
      if (firstQuotes !== -1) {
        // @ts-expect-error acc[firstQuotes] is guaranteed to be defined
        acc[firstQuotes] = acc[firstQuotes].concat(value)
        firstQuotes = -1
      } else {
        acc.push(value)
      }
    } else if (firstQuotes !== -1) {
      // @ts-expect-error acc[firstQuotes] is guaranteed to be defined
      acc[firstQuotes] = acc[firstQuotes].concat(value)
    } else {
      acc.push(value)
    }
    return acc
  }, [])
}
